import {ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation} from '@angular/core';
import {AsyncPipe, NgOptimizedImage} from '@angular/common';
import {DomSanitizer} from '@angular/platform-browser';
import {JsdIconService} from './services/jsd-icon.service';
import {map, Observable, of} from 'rxjs';

@Component({
    selector: 'jsd-icon',
    standalone: true,
    imports: [
        NgOptimizedImage,
        AsyncPipe
    ],
    templateUrl: './jsd-icon.component.html',
    styleUrl: './jsd-icon.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom,
})
export class JsdIconComponent {
    @Input() @HostBinding('style.--icon-font-size') size: string = '16px';
    @Input() @HostBinding('style.--icon-width') width: string = '24px';
    @Input() @HostBinding('style.--icon-height') height: string = '24px';

    svgContent: Observable<any> | null = null;
 
    @Input()
    set iconName(name: string) {
        this.setSvgContent(name ? `assets/icons/${name}.svg` : 'initial');
    }

    constructor(private sanitizer: DomSanitizer, private jdsIconService: JsdIconService) {
    }

    private setSvgContent(iconPath: string): void {
         this.svgContent = this.jdsIconService.getSvgContent(iconPath)
             .pipe(map((content) =>
                 this.sanitizer.bypassSecurityTrustHtml(content)));
    }
}
